var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P } from '@pacem/pacem-core';
import { KnownShader, MaterialElement } from './material';
import { TAG_MIDDLE_NAME } from '../constants';
//namespace Pacem.Components.Drawing3D {
let BasicMaterialElement = class BasicMaterialElement extends MaterialElement {
    constructor() {
        super(KnownShader.Basic);
    }
};
BasicMaterialElement = __decorate([
    CustomElement({ tagName: `${P}-${TAG_MIDDLE_NAME}-material-basic` })
], BasicMaterialElement);
export { BasicMaterialElement };
